import { Component, Inject, inject } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { NavbarComponent } from './core/components/navbar/navbar.component';
import { NotificationHostComponent } from './shared/components/notification-host/notification-host.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LanguageService } from './shared/services/language.services';
import { Store } from '@ngrx/store';
import { AuthenticationService } from './shared/services/authentication.service';
import { UsageTimerService } from './shared/services/usageTimer.service';
import { logoutTimeout, userActions } from './user/store/user.actions';
import { timerActions } from './core/store/timer.actions';
import { ThemeService } from './shared/services/theme.service';
import { LoadingOverlayComponent } from './shared/components/loading-overlay/loading-overlay.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    NavbarComponent,
    NotificationHostComponent,
    LoadingOverlayComponent,
    TranslateModule
  ],
  providers: [
    LanguageService,
    UsageTimerService
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})


export class AppComponent {
  public languageService = inject(LanguageService);
  private store = inject(Store);
  private usageTimerService = inject(UsageTimerService);
  private themeService = inject(ThemeService);

  public authenticationService = inject(AuthenticationService);
  title = 'Calipoli';

  usageTime!: number;
  timeLimitExceeded: boolean = false;

  private router = inject(Router);
  public timerInterval: any;


  constructor() {
    //this.startTimer();
  }

  ngOnInit() {
    this.themeService.initTheme();
    let currentUrl = this.router.url;
    let userToken = this.authenticationService.getUserToken();
    if (userToken && !this.anonymousUrl(currentUrl)) {
      this.store.dispatch(userActions.retryLogin());
    }
  }

  startTimer() {
    this.timerInterval = setInterval(() => {
        this.usageTime = this.usageTimerService.getUsageTimeInMinutes();
        this.store.dispatch(timerActions.updateTimer());
        if (this.usageTimerService.isTimeLimitExceeded()) {
          this.authenticationService.clearUserToken();
          this.store.dispatch(logoutTimeout());
        }
    }, 30000);
  }

  ngOnDestroy() {
      clearInterval(this.timerInterval);
  }

  anonymousUrl(currentUrl: string) :boolean {
     return currentUrl.includes('register') || currentUrl.includes('reset-password') ;
  }
}
